import { Outlet } from 'react-router-dom';
import { Text } from '../../ui/text';
import { useCurrentTeam } from './AdminLayout';

export default function TeamDetail() {
  const { team, loading, error, teamId } = useCurrentTeam();

  if (error) return <Text className="text-red-400">Error: {error}</Text>;
  if (loading || !team) {
    return (
      <Text>Loading {teamId ? <span className="font-mono">{teamId}</span> : 'team'}…</Text>
    );
  }

  return <Outlet />;
}
